import { render, staticRenderFns } from "./SubmitActionBar.vue?vue&type=template&id=c5101006&scoped=true&"
import script from "./SubmitActionBar.vue?vue&type=script&lang=js&"
export * from "./SubmitActionBar.vue?vue&type=script&lang=js&"
import style0 from "./SubmitActionBar.vue?vue&type=style&index=0&id=c5101006&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5101006",
  null
  
)

export default component.exports